import React from 'react';
import * as d3 from 'd3';
import { useI18n } from '@whizz/react-i18n';
import type { ClassReportType, HighlightedProps } from '../../types';
import { SectionLayout } from '../modules';
import { StudentProgress } from '../../../components';

type Props = {
  classReport: ClassReportType;
  showOthersData: boolean;
  hideAverage?: boolean;
  chartIsExpanded?: boolean;
} & HighlightedProps;

const MathsAge = ({
  classReport,
  showOthersData,
  highlightedLabel,
  highlightedIds,
  hideAverage,
  chartIsExpanded,
  onElementClick,
}: Props): JSX.Element => {
  const { translate } = useI18n();

  const value = classReport.mathsAgeAverage.toFixed(2);

  const getHeaderValue = (): string | null => {
    if (highlightedLabel) {
      const studentListWithZeroMathsAgeRemoved = classReport.students.all.filter((student) => highlightedIds.includes(student.id) && student.chartsData.mathsAge > 0);
      const mean = d3.mean(studentListWithZeroMathsAgeRemoved.map((student) => student.chartsData.mathsAge));
      return (mean !== undefined) ? mean.toFixed(2) : null;
    }
    return null;
  };

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.MATHS_AGE.title')}
      value={showOthersData ? value : null}
      highlightLabel={highlightedLabel}
      highlightValue={getHeaderValue()}
      unit={translate('pages.REPORTS.SECTIONS.MATHS_AGE.unit', { count: parseFloat(value) })}
      moreInfo={translate('pages.REPORTS.SECTIONS.MATHS_AGE.info')}
      disableChartToggle={classReport.students.all.length <= 0}
      className={'pdf-no-break'}
      data-cy="maths-age"
      hideAverage={hideAverage}
      chartIsExpanded={chartIsExpanded}
      id='maths-age-container'
    >
      <StudentProgress
        thinAxis
        showOthersData={showOthersData}
        data={classReport.students.all ?? []}
        chartType={'mathsAge'}
        highlightedIds={highlightedIds}
        removeUnassessed={true}
        onElementClick={onElementClick}
      />
    </SectionLayout>
  );
};

export default MathsAge;
